import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import { ToastrService } from 'ngx-toastr';
import {BsModalRef } from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {DonVi} from '../../../models/danhmuc/donvi';
import {DonViService} from '../../../service/danhmuc/service-donvi';
import {TreeViewComponent} from '@syncfusion/ej2-angular-navigations';
import {Staffs} from '../../../models/staff/staffs';
import {StaffsService} from '../../../service/staff/service-staffs';
import {DonViNgoai} from '../../../models/danhmuc/donvingoai';
import {DonViNgoaiService} from '../../../service/danhmuc/service-donvingoai';

@Component({
  templateUrl: './select.component.html'

})
export class SelectUnitsOuterComponent implements OnInit, AfterViewInit {
  public language = language;
  public onClose: Subject<boolean>;
  public selectUnits: Subject<DonViNgoai[]>;
  public showCheckBox: boolean = true;
  public dataTree: DonViNgoai[];
  public dataDonVi: Object[] = [];
  public fieldTree: Object;

  public selectUnitsCheck: Object[] = [];


  public dataSelect: DonViNgoai[];
  @ViewChild('treeview') public tree: TreeViewComponent;


  constructor(public toastr: ToastrService,
              public _bsModalRef: BsModalRef,
              public donViService: DonViNgoaiService
  ) {
  }

  ngAfterViewInit() {

  }

  ngOnInit(): void {
    this.onClose = new Subject();
    this.selectUnits = new Subject();
  }

  public showDonVi(dv: Object[]): void {
    this.selectUnitsCheck = dv;
    this.donViService.getAll().subscribe(x => {
      this.dataTree = x;
      this.dataDonVi = [];
      for (let i = 0; i < this.dataTree.length; i++) {
        this.dataDonVi.push(
          this.dataTree[i].maCapTren == 0 ?
            {
              id: this.dataTree[i].id,
              name: this.dataTree[i].tenCQ,
              hasChild: this.dataTree[i].hasChild,
              expanded: true
            }
            :
            {
              id: this.dataTree[i].id,
              pid: this.dataTree[i].maCapTren,
              name: this.dataTree[i].tenCQ,
              hasChild: this.dataTree[i].hasChild,
              expanded: false
            });
      }
      this.fieldTree = {dataSource: this.dataDonVi, id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild'};

    });

  }

  public show(id: number) {
  }

  public onSelect(): void {

    //this.onClose.next(true);
    this.selectUnits.next(this.dataSelect);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

  public nodeChecked(args): void {
    let arrids: string = this.tree.getAllCheckedNodes().join();
    this.donViService.getAllByIds(arrids).subscribe(dataList => this.dataSelect = dataList);
  }

}
